import React, { useState } from 'react';
import { FaSearch } from 'react-icons/fa';

const ServicesPage = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');

  // Données des services
  const servicesData = {
    categories: [
      { id: 'documents-voyage', name: 'DOCUMENTS DE VOYAGE' },
      { id: 'documents-identite', name: 'DOCUMENTS D\'IDENTITE' },
      { id: 'attestations-certificats', name: 'ATTESTATIONS ET CERTIFICATS' },
      { id: 'legalisation', name: 'LEGALISATION, AUTHENTIFICATION ET NOTARIAT' },
      { id: 'vie-familiale', name: 'VIE FAMILIALE ET STATUT CIVIL' }
    ],
    services: [
      // Documents de voyage
      {
        id: 1,
        category: 'documents-voyage',
        title: 'Visa diplomatique',
        image: 'https://i0.wp.com/rendez-vous.benin-ambassade.fr/wp-content/uploads/2025/09/illustration.png',
        link: '/produit/visa-diplomatique/'
      },
      {
        id: 2,
        category: 'documents-voyage',
        title: 'Passeport biométrique',
        image: 'https://i0.wp.com/rendez-vous.benin-ambassade.fr/wp-content/uploads/2025/09/illustration.png',
        link: '/produit/passeport-biometrique/'
      },
      {
        id: 3,
        category: 'documents-voyage',
        title: 'Laissez-passer consulaire',
        image: 'https://i0.wp.com/rendez-vous.benin-ambassade.fr/wp-content/uploads/2025/09/illustration.png',
        link: '/produit/laissez-passer/'
      },
      {
        id: 4,
        category: 'documents-voyage',
        title: 'e-Visa',
        image: 'https://i0.wp.com/rendez-vous.benin-ambassade.fr/wp-content/uploads/2025/09/illustration-2.png',
        link: 'https://evisa.bj/',
        external: true
      },

      // Documents d'identité
      {
        id: 5,
        category: 'documents-identite',
        title: 'Immatriculation consulaire (INDISPENSABLE)',
        image: 'https://i0.wp.com/rendez-vous.benin-ambassade.fr/wp-content/uploads/2025/09/illustration-2.png',
        link: '/produit/immatriculation-consulaire-indispensable/'
      },
      {
        id: 6,
        category: 'documents-identite',
        title: 'Carte d\'identité consulaire',
        image: 'https://i0.wp.com/rendez-vous.benin-ambassade.fr/wp-content/uploads/2025/09/illustration.png',
        link: '/produit/carte-didentite-consulaire/'
      },

      // Attestations et certificats
      {
        id: 7,
        category: 'attestations-certificats',
        title: 'Autorisation parentale',
        image: 'https://i0.wp.com/rendez-vous.benin-ambassade.fr/wp-content/uploads/2025/09/illustration-2.png',
        link: '/produit/autorisation-parentale/'
      },
      {
        id: 8,
        category: 'attestations-certificats',
        title: 'Attestation de concordance de nom et de date',
        image: 'https://i0.wp.com/rendez-vous.benin-ambassade.fr/wp-content/uploads/2025/09/illustration.png',
        link: '/produit/attestation-de-concordance-de-nom/'
      },
      {
        id: 9,
        category: 'attestations-certificats',
        title: 'Attestation de dépôt',
        image: 'https://i0.wp.com/rendez-vous.benin-ambassade.fr/wp-content/uploads/2025/09/illustration.png',
        link: '/produit/attestation-de-depot/'
      },
      {
        id: 10,
        category: 'attestations-certificats',
        title: 'Attestation de divorce',
        image: 'https://i0.wp.com/rendez-vous.benin-ambassade.fr/wp-content/uploads/2025/09/illustration.png',
        link: '/produit/attestation-de-divorce/'
      },
      {
        id: 11,
        category: 'attestations-certificats',
        title: 'Attestation de nationalité',
        image: 'https://i0.wp.com/rendez-vous.benin-ambassade.fr/wp-content/uploads/2025/09/illustration.png',
        link: '/produit/attestation-de-nationalite/'
      },
      {
        id: 12,
        category: 'attestations-certificats',
        title: 'Attestation de non remariage',
        image: 'https://i0.wp.com/rendez-vous.benin-ambassade.fr/wp-content/uploads/2025/09/illustration.png',
        link: '/produit/attestation-de-non-remariage/'
      },
      {
        id: 13,
        category: 'attestations-certificats',
        title: 'Attestation de non tutelle',
        image: 'https://i0.wp.com/rendez-vous.benin-ambassade.fr/wp-content/uploads/2025/09/illustration.png',
        link: '/produit/attestation-de-non-tutelle-mariage-pacs/'
      },
      {
        id: 14,
        category: 'attestations-certificats',
        title: 'Attestation de résidence',
        image: 'https://i0.wp.com/rendez-vous.benin-ambassade.fr/wp-content/uploads/2025/09/illustration.png',
        link: '/produit/attestation-de-residence/'
      },
      {
        id: 15,
        category: 'attestations-certificats',
        title: 'Certificat de coutume par filiation',
        image: 'https://i0.wp.com/rendez-vous.benin-ambassade.fr/wp-content/uploads/2025/09/illustration.png',
        link: '/produit/certificat-de-coutume-par-filiation/'
      },
      {
        id: 16,
        category: 'attestations-certificats',
        title: 'Certificat de perte',
        image: 'https://i0.wp.com/rendez-vous.benin-ambassade.fr/wp-content/uploads/2025/09/illustration.png',
        link: '/produit/declaration-de-perte/'
      },
      {
        id: 17,
        category: 'attestations-certificats',
        title: 'Certificat de vie',
        image: 'https://i0.wp.com/rendez-vous.benin-ambassade.fr/wp-content/uploads/2025/09/illustration.png',
        link: '/produit/certificat-de-vie/'
      },

      // Vie familiale
      {
        id: 18,
        category: 'vie-familiale',
        title: 'Attestation de transfert de dépouille mortelle',
        image: 'https://i0.wp.com/rendez-vous.benin-ambassade.fr/wp-content/uploads/2025/09/illustration.png',
        link: '/produit/attestation-de-transfert-de-depouille-mortelle/'
      },
      {
        id: 19,
        category: 'vie-familiale',
        title: 'Attestation de transfert d\'urne',
        image: 'https://i0.wp.com/rendez-vous.benin-ambassade.fr/wp-content/uploads/2025/09/illustration.png',
        link: '/produit/transfert-durne/'
      },
      {
        id: 20,
        category: 'vie-familiale',
        title: 'Pacs – mariage (certificat de célibat et de coutume)',
        image: 'https://i0.wp.com/rendez-vous.benin-ambassade.fr/wp-content/uploads/2025/09/illustration.png',
        link: '/produit/pacs/'
      },
      {
        id: 21,
        category: 'vie-familiale',
        title: 'Fiche familiale d\'état civil',
        image: 'https://i0.wp.com/rendez-vous.benin-ambassade.fr/wp-content/uploads/2025/09/illustration.png',
        link: '/produit/fiche-familiale-detat-civil/'
      },

      // Légalisation
      {
        id: 22,
        category: 'legalisation',
        title: 'Authentification / Certification d\'acte',
        image: 'https://i0.wp.com/rendez-vous.benin-ambassade.fr/wp-content/uploads/2025/09/illustration-2.png',
        link: '/produit/authentification-certification-dacte/'
      },
      {
        id: 23,
        category: 'legalisation',
        title: 'Authentification de l\'acte de naissance sécurisé',
        image: 'https://i0.wp.com/rendez-vous.benin-ambassade.fr/wp-content/uploads/2025/09/illustration-2.png',
        link: '/produit/authentification-de-lacte-de-naissance-securise/'
      },
      {
        id: 24,
        category: 'legalisation',
        title: 'Procuration',
        image: 'https://i0.wp.com/rendez-vous.benin-ambassade.fr/wp-content/uploads/2025/09/illustration-2.png',
        link: '/produit/procuration/'
      },
      {
        id: 25,
        category: 'legalisation',
        title: 'Acte notarié',
        image: 'https://i0.wp.com/rendez-vous.benin-ambassade.fr/wp-content/uploads/2025/09/illustration.png',
        link: '/produit/acte-notarie/'
      },
      {
        id: 26,
        category: 'legalisation',
        title: 'Authentification arrêté de renonciation à la nationalité béninoise',
        image: 'https://i0.wp.com/rendez-vous.benin-ambassade.fr/wp-content/uploads/2025/09/illustration.png',
        link: '/produit/authentification-decret-renonciation-de-nationalite/'
      },
      {
        id: 27,
        category: 'legalisation',
        title: 'Authentification de casier judiciaire',
        image: 'https://i0.wp.com/rendez-vous.benin-ambassade.fr/wp-content/uploads/2025/09/illustration.png',
        link: '/produit/authentification-de-casier-judiciaire/'
      },
      {
        id: 28,
        category: 'legalisation',
        title: 'Légalisation d\'acte',
        image: 'https://i0.wp.com/rendez-vous.benin-ambassade.fr/wp-content/uploads/2025/09/illustration.png',
        link: '/produit/legalisation-dacte/'
      }
    ]
  };

  // Filtrer les services
  const filteredServices = servicesData.services.filter(service => {
    const matchesCategory = activeCategory === 'all' || service.category === activeCategory;
    const matchesSearch = service.title.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  // Grouper les services par catégorie pour l'affichage
  const servicesByCategory = servicesData.categories.map(category => ({
    ...category,
    services: filteredServices.filter(service => service.category === category.id)
  })).filter(category => category.services.length > 0);

  return (
    <div className="services-page">
      {/* Header avec recherche et menu */}
      <header className="services-header">
        <div className="search-container">
          <div className="search-box">
            <FaSearch className="search-icon" />
            <input
              type="text"
              placeholder="Rechercher un service"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input"
            />
          </div>

        </div>

        <nav className="categories-nav">
          <ul>
            <li>
              <button
                className={activeCategory === 'all' ? 'active' : ''}
                onClick={() => setActiveCategory('all')}
              >
                Tous les services
              </button>
            </li>
            {servicesData.categories.map(category => (
              <li key={category.id}>
                <button
                  className={activeCategory === category.id ? 'active' : ''}
                  onClick={() => setActiveCategory(category.id)}
                >
                  {category.name}
                </button>
              </li>
            ))}
          </ul>
        </nav>
      </header>

      {/* Contenu principal */}
      <main className="services-main">
        {servicesByCategory.map(category => (
          <section key={category.id} className="category-section">
            <h2 className="category-title">{category.name}</h2>
            <div className="services-grid">
              {category.services.map(service => (
                <div key={service.id} className="service-card">
                  <div className="service-image">
                    <a
                      href={service.link}
                      target={service.external ? "_blank" : "_self"}
                      rel={service.external ? "noopener noreferrer" : ""}
                    >
                      <img src={service.image} alt={service.title} />
                    </a>
                  </div>
                  <h3 className="service-title">
                    <a
                      href={service.link}
                      target={service.external ? "_blank" : "_self"}
                      rel={service.external ? "noopener noreferrer" : ""}
                    >
                      {service.title}
                    </a>
                  </h3>
                  <div className="service-action">
                    <a
                      href={service.link}
                      className="service-button"
                      target={service.external ? "_blank" : "_self"}
                      rel={service.external ? "noopener noreferrer" : ""}
                    >
                      <span className="button-text">En savoir plus</span>
                      <svg className="button-icon" viewBox="0 0 448 512">
                        <path d="M190.5 66.9l22.2-22.2c9.4-9.4 24.6-9.4 33.9 0L441 239c9.4 9.4 9.4 24.6 0 33.9L246.6 467.3c-9.4 9.4-24.6 9.4-33.9 0l-22.2-22.2c-9.5-9.5-9.3-25 .4-34.3L311.4 296H24c-13.3 0-24-10.7-24-24v-32c0-13.3 10.7-24 24-24h287.4L190.9 101.2c-9.8-9.3-10-24.8-.4-34.3z" />
                      </svg>
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </section>
        ))}
      </main>
    </div>
  );
};

export default ServicesPage;